import React, { useState } from "react";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import AddIcon from '@mui/icons-material/Add';
import CancelIcon from '@mui/icons-material/Cancel';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import InputAdornment from '@mui/material/InputAdornment';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { add_project } from "../../../../services/project_service";
import "./AddProjectForm.css";

function AddProjectForm({ onClose, update_project_list, directions }) {

  const [waiting, setWaiting] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    project_manager: "",
    direction: "",
    start_date: null,
    end_date: null,
    estimated_budget: "",
    description: "",
  });

  const [errorText, setErrorText] = useState("");

  const handleChange = (e) => {
    console.log(e.target);
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    setErrorText("");
    const { title, direction, project_manager, start_date, end_date } = formData;

    if (!title || !direction || !project_manager || !start_date || !end_date) {
      setErrorText("Veuillez remplir tous les champs obligatoires.");
      return;
    }

    setWaiting(true);
    try {
      const response = await add_project(formData);
      console.log("Projet ajouté avec succès :", response.data);
      await update_project_list(response.data);
      setWaiting(false);
      onClose();
    } catch (error) {
      setWaiting(false);
      console.error(
        "Erreur lors de l'ajout du projet :",
        error.response?.data || error.message
      );
    }
  };

  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="md" aria-labelledby="form-dialog-title" className="update_porpose" >
      <DialogTitle>Ajouter un nouveau projet</DialogTitle>
      <DialogContent>
        <div className="inputs_container">
          <TextField
            variant='standard'
            margin="dense"
            label="Titre *"
            name="title"
            className="input_form"
            value={formData.title}
            onChange={handleChange}
          />
          <FormControl variant='standard' className="input_form">
            <InputLabel>Direction *</InputLabel>

            <Select value={formData.direction} name="direction" onChange={handleChange}>
              <MenuItem value="null" disabled>
                <em>None</em>
              </MenuItem>
              {
                directions.map((dir) => (
                  <MenuItem key={"dir" + dir.id} value={dir.id}>{dir.title}</MenuItem>
                ))
              }
            </Select>
          </FormControl>
          <TextField
            variant='standard'
            margin="dense"
            label="Chef du projet *"
            name="project_manager"
            className="input_form"
            value={formData.project_manager}
            onChange={handleChange}
          />
        </div>
        <div className="inputs_container">
          <TextField
            variant='standard'
            margin="dense"
            label="Budget estimatif (MAD) *"
            name="estimated_budget"
            className="input_form"
            value={formData.estimated_budget}
            onChange={handleChange}
          />
          <TextField
            variant='standard'
            label="Date de début"
            name="start_date"
            type="date"
            className="input_form"
            value={formData.start_date}
            onChange={handleChange}
            slotProps={{
              input: { startAdornment: (<InputAdornment position="start"> <EventAvailableIcon className="my_icon" /> </InputAdornment>), }
            }}
          />
          <TextField
            variant='standard'
            label="Date de fin"
            name="end_date"
            type="date"
            className="input_form"
            value={formData.end_date}
            onChange={handleChange}
            slotProps={{
              input: { startAdornment: (<InputAdornment position="start"> <EventAvailableIcon className="my_icon" /> </InputAdornment>), }
            }}
          />
        </div>
        <TextField
          label="Description"
          name="description"
          fullWidth
          multiline
          rows={4}
          value={formData.description}
          onChange={handleChange}
        />
      </DialogContent>
      <DialogActions>
        <div className='dialogBottom'>
          <div>
            {
              errorText==""
                ? <></>
                : <p className={errorText ? "col-md-10 error" : "col-md-10 valid-champ"}>
                  {errorText}
                </p>
            }
          </div>
          <div>
            <Button variant="contained" className="submit_but cancel_but" startIcon={<CancelIcon />} onClick={onClose} >
              Annuler
            </Button>
            <Button variant="contained" className="submit_but valide_but" startIcon={<AddIcon />} onClick={handleSubmit} >
              Ajouter
            </Button>
          </div>
        </div>
      </DialogActions>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={waiting}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Dialog>
  );
}

export default AddProjectForm;
